
import { controls } from "../../../../pages/controls";

const rp302 = {
  label: "Scroll",
  starting: true,
  url: "rp302",
  pageLabel: "Receipt Payment GL",
  pageType: "history",
  filter: [
    ...controls.displayText({ label: "Region", width: "col-sm-2" }),
    ...controls.Region(),
    {
      inputType: "showdata",
      tab: "Modal",
      data: "region",
      textcolor: "black",
      name: "region_display",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    ...controls.displayText({ width: "col-sm-6" }),

    ...controls.displayText({ label: "Branch", width: "col-sm-2" }),
    ...controls.branch({ defaultValue: "assigned_branch", isReadOnly: true, isRequired: true, star: true }),
    ...controls.showData({ data: "branch_display", name: "branch_display", width: "col-sm-4" }),

    ...controls.checkBox({ tab: "filter", label: "With Branch", name: "isWitBrabch", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Transaction Type", width: "col-sm-2" }),
    {
      inputType: "select",
      default: "",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "All",
          value: "All"
        },
        {
          label: "Cash",
          value: "Cash"
        },
        {
          label: "Transfer",
          value: "Transfer"
        },
        {
          label: "Clearing",
          value: "Clearing"
        }
      ],
      placeHolder: "Transaction Type",
      name: "TransactionType",
      description: "Enter Transaction Type"
    },
    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),
    ...controls.displayText({ tab: "filter", label: "Receipt/Payment", width: "col-sm-2" }),
    {
      inputType: "select",
      default: "",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "Receipts",
          value: "Receipts"
        },
        {
          label: "Payments",
          value: "Payments"
        },
        {
          label: "Receipts And Payments",
          value: "Receipts And Payments"
        },
        {
          label: "Opening balance Receipts And Payments",
          value: "Opening balance Receipts And Payments"
        }, {
          label: "Receipts Payments and Closing balance",
          value: "Receipts Payments and Closing balance"
        }, {
          label: "Opening Balance Receipts Payments and Closing balance",
          value: "Opening Balance Receipts Payments and Closing balance"
        },
      ],
      placeHolder: "Receipt/Payment",
      name: "receipt_payment",
      description: "Enter Receipt/Payment"
    },
    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),

    ...controls.magicDateLabel({ tab: "filter", star: true, label: "From Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "from_date", width: "col-sm-2", default: "30660000000 ago" }),

    ...controls.magicDateLabel({ tab: "filter", label: "To Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "to_date", width: "col-sm-2", default: "n" }),

    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },

    ...controls.displayText({ label: "General Ledger", tab: "filter", width: "col-sm-2" }),

    ...controls.GL(),
    {
      inputType: "showdata",
      tab: "Modal",
      data: "gl",
      textcolor: "black",
      name: "gl_code_display",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Receipt Payment GL",
    // pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: false,
    displayColumns: [
      {
        Header: "GL",
        accessor: "gl",
        width: 70
      },
      {
        Header: "Description",
        accessor: "description",
        rwidth: "*",
        width: 350
      },

      {
        Header: "Credit",
        columns: [
          {
            Header: "Cash",
            accessor: "credit_cash",
            type: "currency"
          },
          {
            Header: "Transfer",
            accessor: "credit_transfer",
            type: "currency"
          }
        ]
      },
      {
        Header: "Receipt",
        columns: [
          {
            accessor: "receipt",
            type: "currency"
          }
        ]

      },
      {
        Header: "Payment",
        columns: [
          {
            accessor: "payment",
            type: "currency"
          }
        ],

      },
      {
        Header: "Debit",
        columns: [
          {
            Header: "Cash",
            accessor: "debit_cash",
            type: "currency"
          },
          {
            Header: "Transfer",
            accessor: "debit_transfer",
            type: "currency"
          }
        ]
      },
    ]
  }
};

export default rp302;
